var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTetherIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3184 17.4141V21.5244H15.682V17.4141C15.1277 17.4264 14.8727 17.4264 14.3184 17.4141Z",
    fill: "#F79009"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9547 15.9735V14.769C11.3218 14.9017 10.2997 15.1689 9.81152 15.3747C10.3243 15.59 11.3988 15.8457 12.9547 15.9735Z",
    fill: "#F79009"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0449 15.9735C18.6008 15.8457 19.6754 15.59 20.1881 15.374C19.6999 15.1683 18.6779 14.901 17.0449 14.769V15.9735Z",
    fill: "#F79009"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54492 10.5869H13.6358C14.0129 10.5869 14.3176 10.8931 14.3176 11.2705V16.0432C14.7561 16.0583 15.2429 16.0583 15.6813 16.0432V11.2705C15.6813 10.8931 15.9861 10.5869 16.3631 10.5869H20.454V9.21973H9.54492V10.5869Z",
    fill: "#F79009"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C6.72886 0 0 6.74627 0 15.0388C0.823636 34.9898 29.1791 34.9843 30 15.0388C30 6.74627 23.2711 0 15 0ZM21.8182 10.9373C21.8182 11.3146 21.5134 11.6209 21.1364 11.6209H17.0455V13.0639C19.3568 13.2335 21.8182 13.7222 21.8182 15.0388C21.8182 16.3998 19.1516 16.8612 17.0455 17.015V21.8746C17.0455 22.2519 16.7407 22.5582 16.3636 22.5582H13.6364C13.2593 22.5582 12.9545 22.2519 12.9545 21.8746V17.015C10.8491 16.8619 8.18182 16.4005 8.18182 15.0388C8.18182 13.7229 10.6432 13.2335 12.9545 13.0639V11.6209H8.86364C8.48659 11.6209 8.18182 11.3146 8.18182 10.9373V8.20298C8.18182 7.82564 8.48659 7.5194 8.86364 7.5194H21.1364C21.5134 7.5194 21.8182 7.82564 21.8182 8.20298V10.9373Z",
    fill: "#F79009"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTetherIcon);
export default __webpack_public_path__ + "static/media/tether-icon.15bf9b68d52997b00fc6480a96a73e62.svg";
export { ForwardRef as ReactComponent };